export default "__VITE_ASSET__CxfQ9TXL__"